export enum EClientType {
    ChainOrPharmacy = 1,
    Drugstore = 2
}